// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1hVKR","sendOtp":"AuthorizeToLogin_sendOtp__gg-1X"};